const shadows = {
  buttonShadow: '0px 4px 0px #A01313',
  cardSmallShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  cardLargeShadow: '0px 7.03443px 7.03443px rgba(0, 0, 0, 0.25)',
  formShadow: '0px 16px 32px 0px rgba(255, 255, 255, 0.08)',
  selectShadow: '3px 3px 10px 6px rgba(0, 0, 0, 0.06)',
};

export default shadows;
